import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DataShareService {
  private data = new Subject<string>();
  data$ = this.data.asObservable();

  private headerState = new Subject<boolean>();
  headerState$ = this.headerState.asObservable();

  setData(data: string) {
    this.data.next(data);
  }

  hideGlobalHeader(hideHeader: boolean) {
    this.headerState.next(hideHeader);
  }
}